import { AgTechQueryProjection } from "@agtech/core/data/queries/AgTechDataQueries";
import { ContactNote } from "./ContactNoteData";
import { ContactDetails } from "../ContactData";
import { ContactDataGetContactDetailsQuery } from "../ContactDataQueries";

export const ContactDataGetContactNotesQuery: AgTechQueryProjection<{ contactId: number }, ContactDetails, { notes: ContactNote[] }> = {
    query: ContactDataGetContactDetailsQuery,
    projection: (props, data) => ({
        notes: Object.values(data.notes)
    })
}